export default {
    'add-currency': 'إضافة عملة',
    'edit-currency': 'تعديل عملة',
    'currency-name': 'اسم العملة',
    'currency-symbol': 'رمز العملة',
    'equivalent-price-with-system-currency': 'سعر التعادل مع عملة النظام',
    save: 'حفظ',
    cancel: 'إلغاء',
    'currency-equivalent-rate-update-record-for': 'سجل تحديث سعر تعادل عملة الـ',
    'ok': 'موافق',
    'update-currency-price': 'تحديث سعر العملة',
    'update-currency-date': 'تاريخ تحديث السعر',

    'history-headers': {
        'equivalent-price-with-system-currency': 'سعر التعادل مع عملة النظام',
        'update-date': 'تاريخ التحديث',
    },

    headers: {
        'currency-symbol': 'رمز العملة',
        'currency-name': 'اسم العملة',
        'equivalent-price': 'سعر التعادل',
        'actions': 'الأحداث',
    },
    'delete-currency': 'حذف عملة',
    'are-you-sure-you-want-to-delete-the-currency': 'هل أنت متأكد أنك تريد حذف هذه العملة ؟'
}